let activeMicroApp
let examAppOrderConfig
const getActiveMicroAppAndAppSubjectTestOrder = (store) => {
  activeMicroApp = store.getters["AppicationStaticConfig/getActiveMicroApp"] ?? null
  if (activeMicroApp) {
    const applicationStaticConfig = { ...store.getters["AppicationStaticConfig/getApplicationStaticConfig"] }
    examAppOrderConfig = applicationStaticConfig?.microapps[activeMicroApp]?.app_subject_test_order ?? {}
  }
}

/**
 * Reorders an object's keys based on configuration
 * @param {Object} sourceObj - The object to reorder
 * @param {String} orderByKey - The key name to use for ordering (optional)
 * @param {Object} store - Vuex store instance to access getters
 * @returns {Object} - New object with keys in the correct order
 */
function reorderObjectBasedOnSetConfig (sourceObj, orderByKey = null, store) {
  // setting the active microapp and the app order config from the vuex store
  getActiveMicroAppAndAppSubjectTestOrder(store)

  if (!activeMicroApp || !examAppOrderConfig) {
    console.error("Active microapp or exam app order config is not set")
    return sourceObj
  }

  if (!sourceObj || typeof sourceObj !== "object") {
    return sourceObj
  }

  // Create array of [key, value, order] tuples
  const entries = Object.entries(sourceObj).map(([key, value]) => {
    let standardizedKey = orderByKey && value?.[orderByKey] ? standardizeOrderByValOfOrderByKey(value[orderByKey]) : standardizeOrderByValOfOrderByKey(key)

    let appChainMember = Object.keys(examAppOrderConfig).find(e => standardizedKey.includes(e))
    let order = appChainMember ? examAppOrderConfig[appChainMember] : Number.MAX_VALUE

    return [key, value, order]
  })

  // Sort by order
  entries.sort((a, b) => a[2] - b[2])

  // Convert back to object with sorted keys
  const reorderedObj = {}
  entries.forEach(([key, value]) => { reorderedObj[key] = value })

  return reorderedObj
}

/** Reorders a list of app objects based on configuration
 * @param {Array} appObjList - List of app objects to reorder
 * @param {String} orderByKey - The key name to use for ordering (e.g., "app_name" or "app_name_alias")
 * @param {Object} store - Vuex store instance to access getters
 * @returns {void} - The input list is modified in place
 */
function reorderAppObjBasedOnSetConfig (appObjList, orderByKey, store) {
  // setting the active microapp and the app order config
  getActiveMicroAppAndAppSubjectTestOrder(store)

  if (!activeMicroApp || !examAppOrderConfig) {
    console.error("Active microapp or exam app order config is not set")
    return appObjList
  }

  // assign the priority
  for (let appObj of appObjList) {
    let standardizedValOfOrderByKey = standardizeOrderByValOfOrderByKey(appObj[orderByKey])
    let appChainMember = Object.keys(examAppOrderConfig).find(e => standardizedValOfOrderByKey.includes(e))
    if (appChainMember) {
      appObj.sequence_order = examAppOrderConfig[appChainMember]
    }
    else {
      appObj.sequence_order = Number.MAX_VALUE
    }
  }

  // sort the objects in the object list based on the sequesnce_order key
  appObjList.sort((a, b) => a.sequence_order - b.sequence_order)
}

function standardizeOrderByValOfOrderByKey (valOfOrderByKey) {
  return valOfOrderByKey.replaceAll(/[^a-zA-Z0-9]/g, "").toLowerCase()
}

let AppChainOrder = {
  reorderObjectBasedOnSetConfig,
  reorderAppObjBasedOnSetConfig
}

export { AppChainOrder, reorderObjectBasedOnSetConfig, reorderAppObjBasedOnSetConfig }
export default AppChainOrder
